<template>

	<div>
		<b-button variant="info" v-b-modal.create-testuser-modal style="margin-right: 10px">Create</b-button>
		<b-modal id="create-testuser-modal" title="Create Test User" @ok="handleOk">
			<b-form ref="create-user-form">
				<b-form-group id="formgroup-testusers-create" label="In what systems do you want the test user(s)?" vb-tooltip.hover :title="systemHelpText">
				<b-form-invalid-feedback :state="valid">If SIS is selected, you must also select UPS.</b-form-invalid-feedback>

				<b-form-checkbox-group id="group-create-testusers-systems" v-model="selectedSystems" :options="systemOptions"  >
	<!-- 				<b-form-checkbox disabled value="ldap">LDAP</b-form-checkbox>
					<b-form-checkbox value="ups">UPS</b-form-checkbox>
					<b-form-checkbox value="sis">SIS</b-form-checkbox> -->
				</b-form-checkbox-group>
				</b-form-group> 
				<b-form-group id="group-create-testuser-activated" label="What kind of test user?">
					<b-form-checkbox id="radio-activated-create-testuser" v-model="activated">Activated?</b-form-checkbox>
					<b-form-checkbox id="radio-student-create-testuser" v-model="student">Student?</b-form-checkbox>
					<b-form-checkbox id="radio-employee-create-testuser" v-model="employee">Employee?</b-form-checkbox>
					<b-form-checkbox id="radio-affiliate-create-testuser" v-model="affiliate">Affiliate?</b-form-checkbox>
				</b-form-group>

				<b-form-group id="group-password" label="Testuser Password:">
					<b-form-input type="text" id="input-create-testuser-password"  v-model="userPassword" ></b-form-input>
				</b-form-group>
				<b-form-group id="group-uid-parameters" label="UID Prefix:">
					<b-form-input type="text" id="input-create-testuser-uidprefix"  v-model="uidPrefix" ></b-form-input>
				</b-form-group>
				<b-form-group id="group-count-parameters" label="Count:">
					<b-form-input type="number" id="input-create-testuser-count"  v-model="count" ></b-form-input>
				</b-form-group>
				<b-form-group id="group-ldapOU-parameters" label="LDAP OU:">
					<b-form-select :options="possibleLDAPOUs" id="input-create-testuser-count"  v-model="ldapOU" ></b-form-select>
				</b-form-group>
				<b-form-group id="group-additionalAttributes-parameters" label="Additional Attributes:">
					<b-input-group  class="mb-2">
						<b-form-textarea 
							v-model="additionalAttributes"
							aria-label="Attribute Name" 
							:placeholder="'umServices: \'cloud:gafe\'\n...'">
						</b-form-textarea>
					</b-input-group> 
				</b-form-group>
			</b-form>
		</b-modal>
	</div>

</template>


<script>

const yaml = require('js-yaml')

import {CREATE_TEST_USER} from '../../store/actions/testusers'
const systemMapping = {
	"testuser.create" : {value: "ldap", text: "LDAP", disabled: true},
	"testuser.create.sis" : {value: "sis", text: "SIS"},
	"testuser.create.ups" : {value: "ups", text: "UPS (IDMREG)"}
}
export default {
	name: 'CreateTestuser',
	data() {
		return {
			userPassword: `{SASL}${this.$store.getters.jwtSubject}@UMD.EDU`,
			uidPrefix: "tst",
			count: 1,
			activated: true,
			student: true,
			employee: true,
			affiliate: false,
			additionalAttributes: '',
			selectedSystems: ['ldap'],
			possibleLDAPOUs: [
				{value: "ou=people,dc=umd,dc=edu", text: "ou=people,dc=umd,dc=edu"},
				{value: "ou=extended-service,dc=umd,dc=edu", text: "ou=extended-service,dc=umd,dc=edu"},
				{value: "ou=guest,dc=umd,dc=edu", text: "ou=guest,dc=umd,dc=edu"}
			],
			ldapOU: "ou=people,dc=umd,dc=edu"
		}
	},
	computed: {
		systemOptions() {
			

			return Object.entries(systemMapping).map(([scope,option]) => {
				const userScopes = this.$store.getters.jwtScopes
				const isDisabled =  (scope!=="testuser.create" && userScopes.includes(scope)) ? false : true
				return {
					...option,
					disabled: isDisabled
				}
			})
		},
		systemHelpText() {
			//todo, this shouldn't just be in a tooltip.
			const scopes = this.$store.getters.jwtScopes
			let tooltip =  `You have permission to create users in: ${scopes.filter((scope) => systemMapping[scope]).map((scope) =>  {
						return " " + systemMapping[scope]?.text  
			})}`

			if(scopes.filter((scope) => systemMapping[scope]).length < 3) {
				tooltip = tooltip + ". If you believe you should have access to other systems for creating testusers, please contact the IAM team at ese-iam-support@umd.edu."
			}
			return tooltip
		},
		valid() {
			return (this.selectedSystems.includes('sis')) ? this.selectedSystems.includes('ups') : true
		}
	},

	props: {
		visible: Boolean
	},
	methods: {
		checkFormValidity() {
			const valid = this.$refs.form.checkValidity()
			this.nameState = valid
		},

		addAdditionalAttributeRow() {
			this.additionalAttributes.push({key: this.additionalAttributes.length-1, value: ""})
		},

		handleOk(modalEvt) {
			modalEvt.preventDefault()
			this.handleSubmit()
		},

		async handleSubmit() {
			if(!this.checkFormValidity) {
				return
			}

			try {
				//convert an array of entries to a single object
				let otherAttributes = {}
				try {
					otherAttributes = yaml.safeLoad(this.additionalAttributes)
				} catch(error) {

					this.$store.commit("UPDATE_MESSAGE", "Invalid YAML was passed.")
				}
				await this.$store.dispatch(CREATE_TEST_USER,{
					ldapAttributes: {userPassword: this.userPassword, ...otherAttributes},
					uidPrefix: this.uidPrefix,
					count: this.count,
					activated: this.activated ? "TRUE" : "FALSE",
					student: this.student ? "TRUE" : "FALSE",
					employee: this.employee ? "TRUE" : "FALSE",
					affiliate: this.affiliate ? "TRUE" : "FALSE",
					systems: this.selectedSystems,
					ldapOU: this.ldapOU
				})
				this.$bvModal.hide('create-testuser-modal')

			} catch(error) {
				this.$bvModal.hide('create-testuser-modal')
				return error
			}

		}
	}
}
</script>